import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GroupSeriesDto } from '../dtos/group-series.dto';
import { environment } from '../../../../environments/environment';
import { UpdateGroupSeriesDto } from '../dtos/update-group-series.dto';
import { ReorderDto } from '../../../shared/dtos/reorder.dto';

@Injectable({
  providedIn: 'root'
})
export class GroupSerieService {
  constructor(private http: HttpClient) {
  }

  getGroupSeries(locationId: number): Observable<GroupSeriesDto[]> {
    return this.http.get<GroupSeriesDto[]>(`${environment.cenplexBookingApiBaseUrl}/locations/${locationId}/group-series`);
  }

  updateGroupSerie(updateGroupSeriesDto: UpdateGroupSeriesDto): Observable<GroupSeriesDto> {
    return this.http.put<GroupSeriesDto>(`${environment.cenplexBookingApiBaseUrl}/group-series/${updateGroupSeriesDto.groupSeriesId}`, updateGroupSeriesDto);
  }

  reorderGroupSeries(reorderDto: ReorderDto): Observable<void> {
    return this.http.post<void>(`${environment.cenplexBookingApiBaseUrl}/group-series/${reorderDto.objectId}/reorder`, reorderDto);
  }

  uploadGroupSerieImage(groupSeriesId: number, formData: FormData): Observable<void> {
    return this.http.post<void>(`${environment.cenplexBookingApiBaseUrl}/group-series/${groupSeriesId}/image`, formData);
  }

  deleteGroupSerieImage(groupSeriesId: number): Observable<void> {
    return this.http.delete<void>(`${environment.cenplexBookingApiBaseUrl}/group-series/${groupSeriesId}/image`);
  }
}
